import React from "react";
import { Login } from "../../../components";
import { useTranslation } from "react-i18next";

export const HMILogin = () => {
    const { t } = useTranslation();
    return <Login title={t("login.HMI-login")} />;
};
